export default "__VITE_ASSET__Bvyracc4__"